module.exports = __WEBPACK_EXTERNAL_MODULE__923__;